import {useEffect} from 'react';
import {Link} from 'react-router-dom';
import {toAbsoluteUrl} from '../../../_metronic/helpers';
import './home.css';

const Home = () => {
  useEffect(() => {
    // Match the body to the home page background (Creme, or Coal in dark mode)
    const originalBg = document.body.style.backgroundColor;
    document.body.style.backgroundColor =
      document.documentElement.getAttribute('data-bs-theme') === 'dark' ? '#101214' : '#F7F5F2';

    return () => {
      // Restore original background on unmount
      document.body.style.backgroundColor = originalBg;
    };
  }, []);

  return (
    <div className='home-page'>
      {/* Header */}
      <header className='home-header'>
        <img
          src={toAbsoluteUrl('/media/logos/DIIBS_logo_black.png')}
          alt='diibs'
          className='home-logo theme-light-show'
        />
        <img
          src={toAbsoluteUrl('/media/logos/DIIBS_logo_white.png')}
          alt='diibs'
          className='home-logo theme-dark-show'
        />
        <Link to='/auth' className='home-signin-link'>
          Sign In
        </Link>
      </header>

      {/* Hero Section */}
      <section className='home-hero'>
        <p className='home-hero-tagline'>Reservations Reimagined</p>
        <h1 className='home-hero-title'>
          Your Peak Demand Tables, Next Level Value
        </h1>
        <p className='home-hero-subtitle'>
          diibs helps venues maximize revenue through table auctions and premium waitlist access. Let diners bid for the best seats during peak hours while you focus on what matters most.
        </p>
        <Link to='/auth/register-restaurant' className='home-hero-cta'>
          Get Started
        </Link>
      </section>

      {/* Features Section */}
      <section className='home-features'>
        <h2 className='home-features-title'>Why Venues Choose diibs</h2>
        <p className='home-features-subtitle'>
          Powerful tools to increase revenue and streamline operations.
        </p>
        <div className='home-features-grid'>
          {/* Feature 1 */}
          <div className='home-feature-card'>
            <div className='home-feature-icon'>
              <span role='img' aria-label='auction'>&#128296;</span>
            </div>
            <h3 className='home-feature-title'>Table Auctions</h3>
            <p className='home-feature-description'>
              Monetize high-demand time slots by letting diners bid for premium reservations.
              Set your own starting prices and watch revenue grow during peak hours.
            </p>
          </div>

          {/* Feature 2 */}
          <div className='home-feature-card'>
            <div className='home-feature-icon'>
              <span role='img' aria-label='money'>&#128176;</span>
            </div>
            <h3 className='home-feature-title'>Increased Revenue</h3>
            <p className='home-feature-description'>
              Table pricing is based on minimum spend at the venue - 100% of this goes to the venue. Our platform helps you to capitalize on demand and optimize revenue management.
            </p>
          </div>

          {/* Feature 3 */}
          <div className='home-feature-card'>
            <div className='home-feature-icon'>
              <span role='img' aria-label='dashboard'>&#128202;</span>
            </div>
            <h3 className='home-feature-title'>Easy Management</h3>
            <p className='home-feature-description'>
              Manage all your reservations, auctions, and bookings from a single dashboard.
              Real-time updates keep your team informed and your service seamless.
            </p>
          </div>

          {/* Feature 4 */}
          <div className='home-feature-card'>
            <div className='home-feature-icon'>
              <span role='img' aria-label='insights'>&#11088;</span>
            </div>
            <h3 className='home-feature-title'>Customer Insights</h3>
            <p className='home-feature-description'>
              Access reviews, ratings, and analytics to understand your diners better.
              Make data-driven decisions to improve guest satisfaction.
            </p>
          </div>
          {/* Feature 5 */}
          <div className='home-feature-card'>
            <div className='home-feature-icon'>
              <span role='img' aria-label='money'>&#128176;</span>
            </div>
            <h3 className='home-feature-title'>No Subscription Fee</h3>
            <p className='home-feature-description'>
              There is no cost for venues to list reservations, instead users pay a small convenience fee much like buying a ticket to an event.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className='home-cta-section'>
        <h2 className='home-cta-title'>Ready to Maximize Your Revenue?</h2>
        <p className='home-cta-text'>
          Join our network of venues already using diibs to optimize demand and increase profits.
        </p>
        <Link to='/auth' className='home-cta-button'>
          Get Started Now
        </Link>
      </section>

      {/* Footer */}
      <footer className='home-footer'>
        <p className='home-footer-text'>
          <Link to='/privacy-policy' className='home-footer-link'>Privacy Policy</Link>
          <span>|</span>
          <Link to='/terms-and-conditions' className='home-footer-link'>Terms of Service</Link>
          <span>|</span>
          <Link to='/restaurant-terms' className='home-footer-link'>Restaurant Terms</Link>
        </p>
        <p className='home-footer-text' style={{marginTop: '16px'}}>
          &copy; {new Date().getFullYear()} Diibs, Inc. All rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default Home;
